// extracted by mini-css-extract-plugin
export default {"head_item":"styles_head_item__Y+MiB","search":"styles_search__rGjIK","search_inp":"styles_search_inp__CaWg9"};